module.exports = __webpack_public_path__ + "img/portrait-1-thumbnail.25c5e5d5.jpg";